// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, SchemaForm, Col } from "@components";
import type { PropertiesSchema } from "@types";
import type { ReasonToBeExcluded } from "@modules/service/reducer/reporting-parameters/types";
import uiSchema from "./ui-schema";

type Props = $Exact<{
  schema: ?PropertiesSchema,
  reasonToBeExcluded: ?ReasonToBeExcluded,
  onDismissHandler: () => void,
  onSubmit: (data: Object) => void,
  validate: (data: Object, errors: Object) => Object,
  ...PropsFromLocalize,
}>;

export class ReasonsToBeExcludedModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  submitForm = () => {
    this.formRef.current.submit();
  };

  render() {
    return (
      <Modal className="modal-normal">
        <ModalHeader
          toggle={this.props.onDismissHandler}
          className="d-flex justify-content-between"
        >
          {this.props.reasonToBeExcluded
            ? this.props.t("EDIT_REASON_TO_BE_EXCLUDED")
            : this.props.t("ADD_REASON_TO_BE_EXCLUDED")}
        </ModalHeader>
        <ModalBody className="d-flex justify-content-center align-items-center">
          <SchemaForm
            ref={this.formRef}
            schema={this.props.schema}
            formData={this.props.reasonToBeExcluded}
            validate={this.props.validate}
            onSubmit={this.props.onSubmit}
            uiSchema={uiSchema}
            externalSubmit
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.props.onDismissHandler}>
            {this.props.t("CANCEL")}
          </Button>
          <Button
            materialIcon={this.props.reasonToBeExcluded ? "save" : "add_box"}
            type="submit"
            onClick={this.submitForm}
          >
            {this.props.reasonToBeExcluded ? this.props.t("SAVE") : this.props.t("ADD")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(ReasonsToBeExcludedModal);
